import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import { ListFormat } from '../ListFormat';

const StyledBox = styled.section`
  width: 100%;
`;

const StyledHeader = styled.header`
  align-items: center;
  display: flex;
  justify-content: space-between;
  ${props =>
    props.titleWithBorder &&
    mediaqueries.greaterThan('tablet')`
    border-bottom: ${rem('2px')} solid ${props => props.theme.colors.dark};
  `};
`;

const StyledTitle = styled.h2`
  background-color: ${props => props.theme.colors.light};
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${props => props.theme.fontSize.xsmall};
  line-height: ${rem('15px')};
  margin: 0;
  padding: ${rem('6px')} ${rem('10px')} ${rem('6px')} 0;
  text-transform: uppercase;
  ${mediaqueries.greaterThan('desktop')`
    border: 0;
    font-family: ${props => props.theme.fonts.medium};
    font-size: ${props => props.theme.fontSize.small};
    padding: ${rem('6px')} ${rem('10px')} ${rem('6px')} 0;
  `};
`;

const StyledListFormat = styled(ListFormat)`
  display: none;
  ${mediaqueries.greaterThan('tablet')`
    display: flex;
  `};
`;

export { StyledBox, StyledHeader, StyledTitle, StyledListFormat };
